import { AuthenticationService } from '@adgate/common/services/authentication-service';
import { StateService } from '@adgate/common/services/state-service';
import { Component, EventEmitter, inject, OnInit, Output, ViewChild } from '@angular/core';
import { Privilege } from '@adgate/modules/admin/types/privilege.type';
import { Tab, TabAccessorInterface } from '@adgate/common/interfaces/tab-accessor.interface';
import { AdminPanelUsersComponent } from '@adgate/modules/admin/components/admin-panel-users-component/admin-panel-users-component';
import { AdminPanelRolesComponent } from '@adgate/modules/admin/components/admin-panel-roles-component/admin-panel-roles-component';
import { AdminPanelOfficesComponent } from '@adgate/modules/admin/components/admin-panel-offices-component/admin-panel-offices-component';
import { AdminPanelAgenciesComponent } from '@adgate/modules/admin/components/admin-panel-agencies-component/admin-panel-agencies-component';
import { AdminPanelModule } from '@adgate/modules/admin/types/admin-panel-module.interface';
import { QuickSearch } from '@adgate/common/interfaces/quick-search.interface';

@Component({
  selector: 'app-admin-panel-main-component',
  imports: [
    AdminPanelUsersComponent,
    AdminPanelRolesComponent,
    AdminPanelOfficesComponent,
    AdminPanelAgenciesComponent
  ],
  templateUrl: './admin-panel-main-component.html',
  styleUrl: './admin-panel-main-component.scss',
})
export class AdminPanelMainComponent extends TabAccessorInterface implements OnInit, AdminPanelModule, QuickSearch
{
  @ViewChild('tabUsers') tabUsersComponent?: AdminPanelUsersComponent;
  @ViewChild('tabRoles') tabRolesComponent?: AdminPanelRolesComponent;
  @ViewChild('tabOffices') tabOfficesComponent?: AdminPanelOfficesComponent;
  @ViewChild('tabAgencies') tabAgenciesComponent?: AdminPanelAgenciesComponent;

  public TAB_USERS: number          = 0;
  public TAB_ROLES: number          = 1;
  public TAB_OFFICES: number        = 2;
  public TAB_AGENCIES: number       = 3;

  private authService:AuthenticationService = inject(AuthenticationService);
  private stateService:StateService = inject(StateService);

  public adminPanel: any = {
    'users': false,
    'roles': false,
    'offices': false,
    'agencies': false
  };


  constructor()
  {
    super();

    let decodedToken = this.authService.decodeToken( this.stateService.data.userToken );
    this.adminPanel['users'] = this.authService.checkPrivilegeOnToken(decodedToken,[Privilege.ADMI_CREATEANYUSER,Privilege.ADMI_CREATEOFFICEUSERS]);
    this.adminPanel['roles'] = this.authService.checkPrivilegeOnToken(decodedToken,[Privilege.ADMI_CREATEROLE]);
    this.adminPanel['offices'] = this.authService.checkPrivilegeOnToken(decodedToken,[Privilege.ADMI_EDITOFFICES]);
    this.adminPanel['agencies'] = this.authService.checkPrivilegeOnToken(decodedToken,[Privilege.ADMI_EDITAGENCIES,Privilege.ADMI_EDITOFFICEAGENCIES]);

    if( this.adminPanel['users'] ) {
      this.setActiveTab(this.TAB_USERS);
    } else if( this.adminPanel['roles'] ) {
      this.setActiveTab(this.TAB_ROLES);
    } else if( this.adminPanel['offices'] ) {
      this.setActiveTab(this.TAB_OFFICES);
    } else if( this.adminPanel['agencies'] ) {
      this.setActiveTab(this.TAB_AGENCIES);
    }
  }

  ngOnInit(): void 
  {
    let decodedToken = this.authService.decodeToken( this.stateService.data.userToken );
    this.adminPanel['users'] = this.authService.checkPrivilegeOnToken(decodedToken,[Privilege.ADMI_CREATEANYUSER,Privilege.ADMI_CREATEOFFICEUSERS]);
    this.adminPanel['roles'] = this.authService.checkPrivilegeOnToken(decodedToken,[Privilege.ADMI_CREATEROLE]);
    this.adminPanel['offices'] = this.authService.checkPrivilegeOnToken(decodedToken,[Privilege.ADMI_EDITOFFICES]);
    this.adminPanel['agencies'] = this.authService.checkPrivilegeOnToken(decodedToken,[Privilege.ADMI_EDITAGENCIES,Privilege.ADMI_EDITOFFICEAGENCIES]);
  }

  override getTabs(): Tab[] 
  {
    return [
      {tabNum: 0, tabDescription: 'Users', show: this.adminPanel['users']},
      {tabNum: 1, tabDescription: 'Roles', show: this.adminPanel['roles']},
      {tabNum: 2, tabDescription: 'Commercial Offices', show: this.adminPanel['offices']},
      {tabNum: 3, tabDescription: 'Agencies/Customers', show: this.adminPanel['agencies']},
    ];
  }

  getActiveTabComponent(): any
  {
    switch (this.getActiveTab()) {
      case this.TAB_USERS:
        return this.tabUsersComponent!;
      case this.TAB_ROLES:
        return this.tabRolesComponent!;
      case this.TAB_OFFICES:
        return this.tabOfficesComponent!;
      case this.TAB_AGENCIES:
        return this.tabAgenciesComponent!;
      default:
        throw new Error('Unknown active tab');
    }
  }

  onRefresh()
  {
    const activeTabComponent = this.getActiveTabComponent();
    activeTabComponent.onRefresh();
  }

  getQuickSearchPlaceholder(): string
  {
    try {
      const activeTabComponent = this.getActiveTabComponent();
      return activeTabComponent?.getQuickSearchPlaceholder() || '';
    } catch {
      return '';
    }
  }

  onQuickSearch(filter: string | null)
  {
    const activeTabComponent = this.getActiveTabComponent();
    activeTabComponent.onQuickSearch(filter);
  }
}
